"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/ui/CardImage";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
export const VerticalSmallImageNews = t0 => {
  const $ = _c(49);
  const {
    title: t1,
    timeAgo: t2,
    imageSrc: t3,
    slug,
    priority: t4,
    imageMetadata,
    templatetype: t5,
    isliveblog: t6
  } = t0;
  let t7;
  if ($[0] !== t1) {
    t7 = t1 === undefined ? {
      hidden: false,
      value: "\u0BAA\u0BC6\u0BA3\u0BCD \u0BAA\u0BBE\u0BB0\u0BCD\u0B95\u0BCD\u0B95 \u0BAA\u0BCB\u0BA9 \u0BB5\u0BC6\u0BB1\u0BCD\u0BB1\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BB7\u0B95\u0BCD\u0BA4\u0BBF \u0BB5\u0BC8\u0BA4\u0BCD\u0BA4 \u0B9F\u0BCD\u0BB5\u0BBF\u0BB8\u0BCD\u0B9F\u0BCD.!",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const title = t7;
  let imageSrc;
  let isliveblog;
  let priority;
  let t8;
  let templatetype;
  let titleValue;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t6 || $[7] !== title?.value) {
    const timeAgo = t2 === undefined ? {
      hidden: false,
      value: "30 min ago",
      customClass: ""
    } : t2;
    imageSrc = t3 === undefined ? {
      hidden: false,
      value: undefined,
      customClass: ""
    } : t3;
    priority = t4 === undefined ? false : t4;
    let t9;
    if ($[14] !== t5) {
      t9 = t5 === undefined ? {
        hidden: false,
        value: "",
        customClass: ""
      } : t5;
      $[14] = t5;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    templatetype = t9;
    let t10;
    if ($[16] !== t6) {
      t10 = t6 === undefined ? {
        hidden: false,
        value: "",
        customClass: ""
      } : t6;
      $[16] = t6;
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    isliveblog = t10;
    const t11 = title?.value;
    let t12;
    if ($[18] !== t11) {
      t12 = toFieldString(t11);
      $[18] = t11;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    titleValue = t12;
    getTimeAgo(toFieldString(timeAgo?.value));
    t8 = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = title?.value;
    $[8] = imageSrc;
    $[9] = isliveblog;
    $[10] = priority;
    $[11] = t8;
    $[12] = templatetype;
    $[13] = titleValue;
  } else {
    imageSrc = $[8];
    isliveblog = $[9];
    priority = $[10];
    t8 = $[11];
    templatetype = $[12];
    titleValue = $[13];
  }
  const validImageSrc = t8;
  let t9;
  if ($[20] !== isliveblog?.value || $[21] !== templatetype?.value) {
    t9 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[20] = isliveblog?.value;
    $[21] = templatetype?.value;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const isLiveBlog = t9;
  let t10;
  if ($[23] !== imageMetadata || $[24] !== imageSrc?.customClass || $[25] !== imageSrc?.hidden || $[26] !== priority || $[27] !== titleValue || $[28] !== validImageSrc) {
    t10 = !imageSrc?.hidden && <div className={imageSrc?.customClass || ""}><div className="relative w-full aspect-[16/9] overflow-hidden"><Image src={validImageSrc} alt={titleValue} fill={true} className="object-cover w-full h-full" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} priority={priority} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[23] = imageMetadata;
    $[24] = imageSrc?.customClass;
    $[25] = imageSrc?.hidden;
    $[26] = priority;
    $[27] = titleValue;
    $[28] = validImageSrc;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== isLiveBlog || $[31] !== title?.customClass || $[32] !== title?.hidden || $[33] !== titleValue) {
    t11 = !title?.hidden && <h3 className={` text-14-tamil-700 leading-[1.4] text-1B1B1B h-auto ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink />}{titleValue}</h3>;
    $[30] = isLiveBlog;
    $[31] = title?.customClass;
    $[32] = title?.hidden;
    $[33] = titleValue;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  const t12 = slug ? `/${slug}` : undefined;
  let t13;
  if ($[35] !== slug || $[36] !== t12 || $[37] !== titleValue || $[38] !== validImageSrc) {
    t13 = <div className="flex justify-between items-center gap-3"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={validImageSrc} articleUrl={t12} /></div>;
    $[35] = slug;
    $[36] = t12;
    $[37] = titleValue;
    $[38] = validImageSrc;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t11 || $[41] !== t13) {
    t14 = <div className="flex flex-col gap-3">{t11}{t13}</div>;
    $[40] = t11;
    $[41] = t13;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t10 || $[44] !== t14) {
    t15 = <div className="flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4">{t10}{t14}</div>;
    $[43] = t10;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  const content = t15;
  if (slug) {
    const t16 = `/${slug}`;
    let t17;
    if ($[46] !== content || $[47] !== t16) {
      t17 = <Link href={t16} className="block hover:bg-gray-100 transition-colors cursor-pointer">{content}</Link>;
      $[46] = content;
      $[47] = t16;
      $[48] = t17;
    } else {
      t17 = $[48];
    }
    return t17;
  }
  return content;
};